import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID, NgZone } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { DOCUMENT, registerLocaleData } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { CoreModule } from './core/core.module';
import { LoginModule } from './login/login.module';
import { ChangePasswordModule } from './change-password/change-password.module';
import { MainModule } from './main/main.module';
import { ThemeModule } from './theme/theme.module';
import { JoincallModule } from './joincall/joincall.module';

import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbDatepickerModule, NbLayoutRulerService, NbLayoutScrollService, NbPlatform, NbViewportRulerAdapter } from '@nebular/theme';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxMaskModule } from 'ngx-mask';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';

import { PasswordExpiryPopupComponent } from './password-expiry-popup/password-expiry-popup.component';
import { PasswordExpiryEmitter } from './password-expiry-popup/services/password-expiry-emitter.service';
import { PasswordExpiry } from './password-expiry-popup/services/password-expiry.service';
import { CsvErrorsService } from './shared/facades/csv-errors.service';
import { PatientFacadeService } from './main/patients/patients-facade.service';
import { PatientDataFacadeService } from './main/data-upload/patient-data-facade.service';
import { OtpVerificationComponent } from './otp-verification/otp-verification.component';


@NgModule({
  declarations: [
    AppComponent,
    PasswordExpiryPopupComponent,
    OtpVerificationComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ThemeModule.forRoot(),
    AppRoutingModule,
    CoreModule,
    LoginModule,
    ChangePasswordModule,
    MainModule,
    NbEvaIconsModule,
    DeviceDetectorModule,
    NbDatepickerModule.forRoot(),
    NgxChartsModule,
    TranslateModule,
    JoincallModule,
    NgxMaskModule.forRoot({ showMaskTyped: true })
  ],
  providers: [
    PasswordExpiryEmitter,
    PasswordExpiry,
    CsvErrorsService,
    PatientFacadeService,
    PatientDataFacadeService,
  
    // Properly provide NbViewportRulerAdapter
    
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
